import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function Holidays() {
    const [rows, setRows] = useState([]);
    const [date, setDate] = useState("");
    const [label, setLabel] = useState("");
    const [err, setErr] = useState("");

    const load = () => api.get("/holidays").then((r) => setRows(r.data));
    useEffect(() => {
        load();
    }, []);

    const add = async (e) => {
        e.preventDefault();
        setErr("");
        try {
            await api.post("/holidays", { date, label });
            setDate("");
            setLabel("");
            load();
        } catch (ex) {
            setErr(formatApiError(ex));
        }
    };
    const del = async (h) => {
        await api.delete(`/holidays/${h.id}`);
        load();
    };

    return (
        <div className="space-y-4 max-w-2xl" data-testid="holidays-page">
            <div>
                <h1 className="text-2xl font-bold tracking-tight">Holidays</h1>
                <p className="text-xs text-muted-foreground">
                    SLA timers skip these dates for every tier. 2026 national Indian holidays are seeded — add your West Bengal regional days.
                </p>
            </div>
            <form
                onSubmit={add}
                className="flex gap-2 items-end bg-card border border-border rounded-md p-3"
            >
                <div>
                    <label className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono">
                        Date
                    </label>
                    <input
                        data-testid="holiday-date-input"
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required
                        className="bg-background border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:border-primary"
                    />
                </div>
                <div className="flex-1">
                    <label className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono">
                        Label
                    </label>
                    <input
                        data-testid="holiday-label-input"
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}
                        required
                        className="w-full bg-background border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:border-primary"
                    />
                </div>
                <button
                    data-testid="holiday-add-btn"
                    className="px-3 py-2 bg-primary text-primary-foreground rounded-md text-sm inline-flex items-center gap-1"
                >
                    <Plus className="size-3.5" /> Add
                </button>
            </form>
            {err && (
                <div className="text-xs text-red-400 border border-red-500/30 bg-red-500/10 px-3 py-2 rounded-md">
                    {err}
                </div>
            )}
            <div className="bg-card border border-border rounded-md divide-y divide-border">
                {rows.map((h) => (
                    <div
                        key={h.id}
                        className="flex items-center gap-3 px-3 py-2 text-sm"
                        data-testid={`holiday-row-${h.id}`}
                    >
                        <div className="font-mono w-32">{h.date}</div>
                        <div className="flex-1">{h.label}</div>
                        <button
                            data-testid={`holiday-delete-${h.id}`}
                            onClick={() => del(h)}
                            className="text-xs text-red-400 hover:text-red-300"
                        >
                            <Trash2 className="size-3.5" />
                        </button>
                    </div>
                ))}
                {rows.length === 0 && (
                    <div className="text-sm text-muted-foreground p-6 text-center">
                        No holidays.
                    </div>
                )}
            </div>
        </div>
    );
}
